import { useNavigate } from 'react-router-dom'
import { BsArrowLeft } from "react-icons/bs"

const ArrowBackButton = ({isTwoSection, title, path=-1}) => {
    const navigate = useNavigate()
    
    return(
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '0'
        }}>
            <button
                onClick={() => navigate(path)}
                style={{
                    background: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: 'none',
                    transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(to bottom right, #028A9B 0%, #026A8C 100%)'
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)'
                }}
                title="Go back"
            >
                <BsArrowLeft style={{fontSize: '20px'}} />
            </button>
            <h3 style={{
                margin: 0,
                fontWeight: '600',
                color: '#212529',
                fontSize: '1.75rem'
            }}>
                {title}
            </h3>
        </div>
    )
}

export default ArrowBackButton
